import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
import Chat from "./pages/chat/Chat";
import "./font/montserrat/stylesheet.css";
import "./index.css";
import NoPage from "./pages/NoPage";
import AILiveShow from "./pages/ailiveshow/AILiveShow";
import AILiveShowController from "./pages/ailiveshow/AILiveShowController";
import AILiveShowAdmin from "./pages/ailiveshow/AILiveShowAdmin";
import IftarExchangeLive from "./pages/iftarExchange/IftarExchangeLive";
import IftarQR from "./pages/iftarExchange/IftarQR";
import IftarDashboard from "./pages/iftarExchange/IftarDashboard";
import IftarSummarize from "./pages/iftarExchange/IftarSummarize";
import IftarReset from "./pages/iftarExchange/IftarReset";
import IftarPolling from "./pages/iftarExchange/IftarPolling";
import IftarPollHome from "./pages/iftarExchange/IftarPollHome";
import IftarNoPhase from "./pages/iftarExchange/IftarNoPhase";
import IftarNoPhaseMobile from "./pages/iftarExchange/IftarNoPhaseMobile";
import IftarDashboardNew from "./pages/iftarExchange/IftarDashboardNew";
import IftarSummarizeNew from "./pages/iftarExchange/IftarSummarizeNew";
import IftarExchangeAdmin from "./pages/iftarExchange/IftarExchangeAdmin";

const cookies = new Cookies();

function App() {
  const [loading, setLoading] = useState(true);
  const [sessionValid, setSessionValid] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get("token");

    if (tokenFromUrl) {
      console.log("🔑 Token from URL:", tokenFromUrl);
      cookies.set("sessionToken", tokenFromUrl, { path: "/" });
      // Hapus query string agar bersih setelah token disimpan
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    const sessionToken = cookies.get("sessionToken", { path: "/" });
    console.log("Session Token:", sessionToken);

    if (!sessionToken) {
      console.log("❌ Tidak ada token, redirect ke /login");
      setLoading(false);
      setSessionValid(false);
      return;
    }

    // Set default header token
    axios.interceptors.request.use(
      (config) => {
        config.headers["x-access-token"] = sessionToken;
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Cek session ke backend
    axios
      .get(`${process.env.REACT_APP_PATH_DESTINATION}/getSessionChatBot`)
      .then((res) => {
        if (res.data.status === "200") {
          console.log("✅ Session valid:", res.data.data);
          cookies.set("sessionExist", true, { path: "/" });
          cookies.set("sessionData", res.data.data, { path: "/" });
          setSessionValid(true);
        } else {
          console.log("⚠️ Session tidak valid, hapus cookie");
          cookies.remove("sessionToken");
          cookies.remove("sessionData");
          cookies.remove("sessionExist");
          setSessionValid(false);
        }
      })
      .catch((err) => {
        console.error("❌ Error cek session:", err);
        cookies.remove("sessionToken");
        cookies.remove("sessionData");
        cookies.remove("sessionExist");
        setSessionValid(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "50px" }}>⏳ Checking session...</div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            sessionValid ? <Chat /> : <Navigate replace to="/nopage" />
          }
        />
        <Route path="/ailiveshow" element={<AILiveShow />} />
        <Route path="/ailiveshowController" element={<AILiveShowController />} />
        <Route path="/ailiveshowAdmin" element={<AILiveShowAdmin />} />
        <Route path="/iftarExchange" element={<Navigate to="/iftarExchange2026" replace />} />
        <Route path="/iftarExchangeQR" element={<IftarQR />} />
        <Route path="/iftarExchangeHome" element={<IftarDashboard />} />
        <Route path="/iftarExchangeSummarize" element={<IftarSummarize />} />
        <Route path="/iftarExchangeReset" element={<IftarReset />} />
        <Route path="/iftarExchangePolling" element={<IftarPolling />} />
        <Route path="/iftarExchangePollingHome" element={<IftarPollHome />} />
        <Route path="/iftarExchangeNoPhase" element={<IftarNoPhase />} />
        <Route path="/iftarExchange2026" element={<IftarExchangeLive />} />
        <Route path="/iftarExchange2026Admin" element={<IftarExchangeAdmin />} />
        <Route path="/iftarExchange2026Home" element={<IftarDashboardNew />} />
        <Route path="/iftarExchange2026Controller" element={<IftarSummarizeNew />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
